<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2023-07-18 16:10:44
-->
<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-input v-model="queryParam.key"
                  size="mini"
                  clearable
                  placeholder="请输入关键词查找" />
      </div>
      <div class="shaixuan-item">
        <el-button type="primary"
                   size="mini"
                   @click="searchClick()"
                   icon="el-icon-search">
          查询
        </el-button>
        <el-button @click="clickItem(0)"
                   type="primary"
                   size="mini"
                   icon="el-icon-plus">
          新增
        </el-button>
      </div>
    </div>
    <!-- 列表展示 -->
    <div class="common-section-bg common-section-body">
      <el-table v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px">
        <el-table-column prop="id"
                         label="id"
                         width="180" />
        <el-table-column prop="name"
                         label="名称"
                         width="200" />
        <el-table-column prop="admin"
                         label="状态">
          <template slot-scope="scope">
            <el-switch size="mini"
                       v-model="scope.row.status"
                       class="drawer-switch"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       :active-value="1"
                       :inactive-value="0"
                       @change="changeStatus(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="220">
          <template slot-scope="scope">
            <el-button type="danger"
                       style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                       size="mini"
                       @click="handlePermission(scope.row)">权限</el-button>
            <el-button type="danger"
                       style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                       size="mini"
                       @click="clickItem(1, scope.row)">修改</el-button>
            <!-- <el-button type="danger"
                       @click="remove(scope.row)"
                       size="mini">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total"
                  :total="total"
                  :page.sync="queryParam.page"
                  :limit.sync="queryParam.size"
                  @pagination="getList" />
    </div>
    <el-drawer custom-class="custom-drawer"
               :visible.sync="showDrawer"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="closeDrawerFun" />
        </div>
      </template>
      <div class="custom-content">
        <RoleAdd ref="RoleAdd"
                 @onUpdateDrawer="onUpdateDrawer($event)" />
      </div>
    </el-drawer>
    <!-- 配权限 -->
    <el-drawer custom-class="custom-drawer"
               :visible.sync="permissionDialogFormVisible"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ $t('user.permission') }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="permissionDialogFormVisible = false" />
        </div>
      </template>
      <div class="custom-content pdl30"
           v-loading="dialogFormLoading">
        <div v-loading="dialogFormLoading">
          <el-tree ref="tree"
                   :data="permissions"
                   show-checkbox
                   node-key="id"
                   default-expand-all
                   :props="defaultProps">
          </el-tree>
        </div>
        <div class="fix-fotter"
             v-if="dialogFormLoading === false">
          <div class="default-btn pointer"
               @click="setPermission()"> {{ $t('table.confirm') }}</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Role from "@/api/role";
import RoleAdd from "./RoleAdd.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data () {
    return {
      setPermissionData: {},
      dialogFormLoading: false,
      permissionDialogFormVisible: false,
      permissions: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      queryParam: {
        key: "",
        page: 1,
        size: 10,
      },
      total: 0,
      listLoading: false,
      tableData: [],
      isEdit: 0, // 0新增 1编辑
      showDrawer: false,
    };
  },
  components: {
    Pagination,
    RoleAdd,
  },
  created () {
  },
  mounted () {
    this.getList();
  },
  methods: {
    // 展示修改权限
    handlePermission(row) {
      this.setPermissionData.id = row.id
      this.dialogFormLoading = true
      this.permissionDialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([])
      })
      Role.menuTree({
        role_id: row.id
      }).then((res) => {
        this.permissions = this.localPermissionTree(res.result.tree)
        this.$nextTick(() => {
          res.result.role_permission_ids.forEach((item) => {
            if (this.$refs.tree.getNode(item).isLeaf) {
              this.$refs.tree.setChecked(item, true)
            }
          })
        })
        this.dialogFormLoading = false
      })
    },
    localPermissionTree (tree) {
      tree.forEach((permissionItem) => {
        permissionItem.name = this.$te('route.' + permissionItem.name) ? this.$t('route.' + permissionItem.name, 'zh') : permissionItem.name
        if (permissionItem.children && permissionItem.children.length > 0) {
          this.localPermissionTree(permissionItem.children)
        }
      })
      return tree
    },
    // 修改权限
    setPermission () {
      var permissionIds = []
      this.$refs.tree.getCheckedNodes(false, true).forEach((item) => {
        permissionIds.push(item.id)
      })
      Role.rolePriv({
        role_id: this.setPermissionData.id,
        menu_id: permissionIds
      }).then((res) => {
        this.dialogFormLoading = false
        this.permissionDialogFormVisible = false
        this.$message.success(this.$t('form.updateSuccess'))
        this.handleFilter()
      })
    },
    /**
 * @name: 更改状态
 * @param {*} val
 * @return {*}
 * @desc:
 */
    changeStatus (val) {
      let params = {
        role_id: val.id,
        status: val.status
      };
      Role.status(params).then(res => {
        if (res.code == 200) {
          this.getList();
        } else {
          this.getList();
          this.$message.error(res.message);
        }
      })
    },
    // 更新弹层状态
    onUpdateDrawer (status) {
      console.log("status", status);
      if (status == 1) {
        // 成功
        this.showDrawer = false;
        this.getList();
      } else if (status == -1) {
        // 失败
        this.showDrawer = false;
      }
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc:
     */
    closeDrawerFun () {
      this.showDrawer = false;
      this.$refs.RoleAdd.resetForm();
    },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc:
     */
    clickItem (type, row) {
      let that = this;
      this.showDrawer = true;
      this.isEdit = type;
      // 给组件传值
      let obj = {
        type: type,
        id: row ? row.id : "",
      };
      this.$nextTick(function () {
        that.$refs.RoleAdd.initFun(obj);
      });
    },
    /* 查询按钮，页码重置，查询数据 */
    searchClick () {
      this.queryParam.page = 1;
      this.getList();
    },
    /* 查询tableData数据 */
    getList () {
      let that = this;
      this.listLoading = true;
      Role.list(that.queryParam).then((res) => {
        that.listLoading = false;
        that.tableData = res.result.list;
        that.total = res.result.total;
      });
    },
    remove (row) {
      let that = this;
      that.$confirm("确定删除该内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用接口
          Role.remove({ role_id: row.id }).then((res) => {
            if (res.code == 200) {
              that.$message.success(res.message);
              that.getList();
            } else {
              that.$message.error(res.message);
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
